import React, { Component } from 'react'

import { connect } from 'react-redux'
import * as api from '../../api/api'
import * as actions from '../../actions'
  
import { Button} from 'rmwc/Button';
import { Link } from 'react-router-dom'

import {TextField} from 'rmwc/TextField';


import SerializeForm from 'form-serialize'

import {
  Card
} from 'rmwc/Card';

import { Snackbar } from 'rmwc/Snackbar';
import { Typography } from 'rmwc/Typography';
import { Grid, GridCell } from 'rmwc/Grid';
import ReactExport from "react-data-export";

import StatusMessage from '../../util/StatusMessage'


class TPOHallticketAdmin extends Component {
  constructor(props) {
    super(props)
    this.state = {
      status: '',
      errorMsg: '',
      downloadDisable:true,
      exportMaxNumRecords: 5000,
      data: {        
        start: 1,
        end: 5000,
        exportData:[],
        
      }
    }
    
    
  }


  componentDidMount() {
  
  }

  onInputChange = evt => {
    const data = Object.assign({}, this.state.data);
    data[evt.target.name] = evt.target.value;
    this.setState({data});
  };

  onHallTicketIDChangeForExport = evt => {
    const data = Object.assign({}, this.state.data);
    data[evt.target.name] = evt.target.value;
    data.end = parseInt(data.start)+parseInt(this.state.exportMaxNumRecords)-1
    this.setState({data, downloadDisable:true});
  };

  
  handleExportUserData = e => {
    e.preventDefault()
    let data = Object.assign({}, this.state.data)
    if(!this.state.downloadDisable){
      this.setState({downloadDisable: true})
    }
    if(data.start > 0){
      api.exportTPOHallTicketData(this.props.user.accessToken, data.start).then((result) => {
        const { status, errors} = result
          if (status === 'success') {
            data.exportData = result.data
            this.setState({data:data, errorMsg:'', downloadDisable:false})
          }
        })
        .catch((err) => {
          this.setState({ errorMsg: 'Error in Fetching Details', downloadDisable:true })
        })
    }
    else{
      this.setState({errorMsg: 'Please provide valid id for export'})
    }
    
    }

    render() {
    
      const ExcelFile = ReactExport.ExcelFile;
      const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
      const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
      let exportComponent =(
         <div className="">
              <TextField  className='text_input' type="number" label="Id From" autoComplete="off" name="start" onChange={this.onHallTicketIDChangeForExport} value={this.state.data.start}/>
              <TextField  className='text_input' type="number" disable label="To" autoComplete="off" name="start" value={this.state.data.end}/>
              <Button onClick={this.handleExportUserData}>Export</Button>
              <ExcelFile element={<Button disabled={this.state.downloadDisable}>Download</Button>}>
                <ExcelSheet data={this.state.data.exportData} name="userexport">
                    <ExcelColumn label="user_id" value="user_id"/>
                    <ExcelColumn label="name" value="name"/>
                    <ExcelColumn label="test_track" value="test_track"/>
                    <ExcelColumn label="test_centre" value="test_centre"/>
                    <ExcelColumn label="roll_number" value="roll_number"/>
                    <ExcelColumn label="pinvalue" value="pinvalue"/>
                    <ExcelColumn label="time_slot" value="time_slot"/>
                    <ExcelColumn label="test_duration" value="test_duration"/>
                    <ExcelColumn label="reporting_time" value="reporting_time"/>
                    <ExcelColumn label="test_centre_address" value="test_centre_address"/>
                    <ExcelColumn label="land_mark" value="land_mark"/>
                    <ExcelColumn label="pincode" value="pincode"/>
                    <ExcelColumn label="downloaded" value="downloaded"/>
                    <ExcelColumn label="updated_at" value="updated_at"/>
                    <ExcelColumn label="certification_participation_id" value="certification_participation_id"/>
                    <ExcelColumn label="tpo_certification_detail_id" value="tpo_certification_detail_id"/>
                    <ExcelColumn label="id" value="id"/>


                </ExcelSheet>
              </ExcelFile>
            </div>
        )     

      return (
        <Grid>
          <GridCell span="12">
            <div>HallTicket Export</div>
            <div className="opportunity-top-bar">
            <br/>
            
              {exportComponent}  
            
            <StatusMessage error_msg = {this.state.errorMsg}/>
            </div>

          </GridCell>
        </Grid>
      )
    
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(TPOHallticketAdmin);


// WEBPACK FOOTER //
// ./src/views/admin/TPOHallticketAdmin.jsx